import { create } from 'zustand';
import { supabase } from '../lib/supabase';

export const useAuthStore = create((set, get) => ({
  user: null,
  profile: null,
  loading: true,

  initialize: async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      
      if (session?.user) {
        await get().loadUserProfile(session.user);
      } else {
        set({ user: null, profile: null, loading: false });
      }

      supabase.auth.onAuthStateChange(async (event, session) => {
        console.log('Auth event:', event);
        
        if (event === 'SIGNED_IN' && session?.user) {
          await get().loadUserProfile(session.user);
        } else if (event === 'SIGNED_OUT') {
          set({ user: null, profile: null, loading: false });
        } else if (event === 'TOKEN_REFRESHED' && session?.user) {
          await get().loadUserProfile(session.user);
        }
      });
    } catch (error) {
      console.error('Auth init error:', error);
      set({ user: null, profile: null, loading: false });
    }
  },

  loadUserProfile: async (authUser) => {
    try {
      const { data: profile, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', authUser.id)
        .single();

      if (error) {
        set({
          user: { id: authUser.id, email: authUser.email, isAdmin: false, surveyCompleted: false },
          profile: null,
          loading: false
        });
        return;
      }

      const isAdmin = profile?.is_admin === true || profile?.admin === true || profile?.role === 'admin';
      const surveyCompleted = profile?.survey_completed === true;

      set({
        user: { id: authUser.id, email: authUser.email, isAdmin, surveyCompleted },
        profile: { ...profile, is_admin: isAdmin, survey_completed: surveyCompleted },
        loading: false
      });
    } catch (error) {
      console.error('Profile load error:', error);
      set({
        user: { id: authUser.id, email: authUser.email, isAdmin: false, surveyCompleted: false },
        profile: null,
        loading: false
      });
    }
  },

  refreshProfile: async () => {
    const { data: { user: authUser } } = await supabase.auth.getUser();
    if (authUser) {
      await get().loadUserProfile(authUser);
    }
  },

  logout: async () => {
    await supabase.auth.signOut();
    set({ user: null, profile: null, loading: false });
  }
}));

useAuthStore.getState().initialize();
